module.exports = __webpack_public_path__ + "static/form-bg-0ff3a0fc9a7503c9dbd1c6b0d4659aef.jpg";